<template>
  <div>
    <img style="width: 100%;" src="../assets/product-banner.png">
    <el-row type="flex" justify="center">
      <el-col :span="24" style="width: 1280px">
        <el-row>
          <img style="width: 100%;" src="../assets/product-content-0.png">
        </el-row>
        <el-row>
          <img style="width: 100%;" src="../assets/product-content-1.png">
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'Product',
  data(){
    return{
       imgs: [
        // {
        //   id: "01",
        //   src: require("../assets/cp001.jpg"),
        //   name: "M222G GPRS血压血糖仪",
        // },
        // {
        //   id: "02",
        //   src: require("../assets/cp002.jpg"),
        //   name: "A666G GPRS血压计",
        // },
        // {
        //   id: "03",
        //   src: require("../assets/cp003.jpg"),
        //   name: "G-777G GPRS血糖仪套装",
        // },
        // {
        //   id: "04",
        //   src: require("../assets/cp04.jpg"),
        //   name: "G-425S 血糖试纸+采血针",
        // },
        // {
        //   id: "05",
        //   src: require("../assets/cp05.jpg"),
        //   name: "G-423MS 血糖试纸+采血针",
        // },
        // {
        //   id: "06",
        //   src: require("../assets/cp06.jpg"),
        //   name: "      电子血压计",
        // },
        // {
        //   id: "07",
        //   src: require("../assets/cp07.jpg"),
        //   name: "      红外体温计",
        // },
        // {
        //   id: "08",
        //   src: require("../assets/cp08.jpg"),
        //   name: "       听诊器",
        // },
      ],
      mimgs: [
        // {
        //   id: "01",
        //   src: require("../assets/cp09.jpg"),
        //   name: "云南白药气雾剂",
        // },
        // {
        //   id: "02",
        //   src: require("../assets/cp10.jpg"),
        //   name: "小儿感冒颗粒",
        // },
        // {
        //   id: "03",
        //   src: require("../assets/cp11.jpg"),
        //   name: "Elevit爱乐维复合维生素片",
        // },
        // {
        //   id: "04",
        //   src: require("../assets/cp12.jpg"),
        //   name: "碳酸钙D3颗粒",
        // },
      ],
    }
  },
}
</script>
